(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial"]) return;
  try {
    
document.querySelector(".editorial__arrow--left").addEventListener("click", ()=>{
  let actualId = parseInt(document.querySelector(".editorial__wrapper").dataset.id);
  let objects = document.querySelectorAll(".editorial__wrapper product-card-link");

  actualId = (actualId + objects.length - 1)%objects.length;
  document.querySelector(".editorial__wrapper").dataset.id = actualId;

  objects.forEach(object => {
    object.style.display = "none";
  })

  objects[actualId].style.display = "block";
})

document.querySelector(".editorial__arrow--right").addEventListener("click", ()=>{
  let actualId = parseInt(document.querySelector(".editorial__wrapper").dataset.id);
  let objects = document.querySelectorAll(".editorial__wrapper product-card-link");

  actualId = (actualId + + 1)%objects.length;
  document.querySelector(".editorial__wrapper").dataset.id = actualId;

  objects.forEach(object => {
    object.style.display = "none";
  })

  objects[actualId].style.display = "block";
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-artist"]) return;
  try {
    
  (function () {
    const overlay = document.getElementById('artists-overlay');
    const follower = document.getElementById('artists-cursor-follower');
    if (!overlay || !follower) return;

    const followerImg = follower.querySelector('.artists-cursor-follower__image img');
    const followerLabel = follower.querySelector('.artists-cursor-follower__label');

    const canShowFollower = window.matchMedia('(hover: hover) and (min-width: 1200px)').matches;
    if (!canShowFollower) return;

    document.addEventListener('mousemove', (e) => {
      follower.style.left = e.clientX + 'px';
      follower.style.top = e.clientY + 'px';
    });

    document.querySelectorAll('.artists-page__style-card').forEach(card => {
      card.addEventListener('mouseenter', () => {
        const imgUrl = card.dataset.image;
        const name = card.dataset.name;

        followerLabel.textContent = name;

        if (imgUrl) {
          followerImg.src = imgUrl;
          follower.querySelector('.artists-cursor-follower__image').style.display = 'block';
        } else {
          follower.querySelector('.artists-cursor-follower__image').style.display = 'none';
        }

        overlay.classList.add('is-active');
        follower.classList.add('is-active');
      });

      card.addEventListener('mouseleave', () => {
        overlay.classList.remove('is-active');
        follower.classList.remove('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var container = document.getElementById('reviews-container');
  var btn = document.getElementById('reviews-btn');
  var fade = document.getElementById('reviews-fade');
  var actions = document.getElementById('reviews-actions');

  if (!container || !btn) return;

  var step = 1;

  function updateVisibility() {
    var fullyVisible = container.scrollHeight <= container.clientHeight + 2;
    if (fade) fade.style.display = fullyVisible ? 'none' : '';
    if (actions) actions.style.display = fullyVisible ? 'none' : '';
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateVisibility, 150);
  }

  window.addEventListener('load', updateVisibility);
  window.addEventListener('resize', onResize);

  btn.addEventListener('click', function () {
    step++;
    container.style.maxHeight = (step * 120) + 'dvh';
    setTimeout(updateVisibility, 650);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var accordions = document.querySelectorAll('#prod-accordions .prod-accordion');
  accordions.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        accordions.forEach(function (other) {
          if (other !== details && other.open) other.open = false;
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function () {
  var accordions = document.querySelectorAll('#prod-accordions .tab-accordion');
  accordions.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        accordions.forEach(function (other) {
          if (other !== details && other.open) other.open = false;
        });
      }
    });
  });

  document.querySelectorAll('.baf-product-detail-rating[href="#baf-product-reviews"]').forEach(function (reviewsLink) {
    reviewsLink.addEventListener('click', function (event) {
      var reviews = document.getElementById('baf-product-reviews');
      if (!reviews) return;

      event.preventDefault();

      var root = document.documentElement;
      var header = document.querySelector('#header-component');
      var wearSubnav = document.querySelector('.header__wear-subnav[data-baf-scroll-subnav]');
      var stickyBar = document.querySelector('#klav-sticky.klav-sticky--bar:not([hidden])');
      var rootStyles = window.getComputedStyle(root);
      var bodyStyles = window.getComputedStyle(document.body);
      var headerHeight = Math.max(
        parseFloat(rootStyles.getPropertyValue('--baf-stable-header-height')) || 0,
        parseFloat(rootStyles.getPropertyValue('--header-height')) || 0,
        parseFloat(bodyStyles.getPropertyValue('--header-height')) || 0,
        header ? header.getBoundingClientRect().height : 0
      );
      var wearSubnavHeight = Math.max(
        parseFloat(rootStyles.getPropertyValue('--baf-scroll-subnav-height')) || 0,
        wearSubnav ? wearSubnav.getBoundingClientRect().height : 0
      );
      var stickyBarVisible = Boolean(
        stickyBar &&
        root.classList.contains('klav-sticky-as-bar') &&
        root.classList.contains('klav-sticky-visible')
      );
      var stickyBarHeight = stickyBarVisible
        ? Math.max(
            parseFloat(bodyStyles.getPropertyValue('--klav-sticky-bar-height')) || 0,
            stickyBar.getBoundingClientRect().height || 0
          )
        : 0;
      var reviewsTop = reviews.getBoundingClientRect().top + window.scrollY
        - headerHeight
        - wearSubnavHeight
        - stickyBarHeight
        - 16;
      var lenis = window.BarkFrameLenis || window.lenis || null;

      if (lenis && typeof lenis.scrollTo === 'function') {
        try {
          lenis.scrollTo(Math.max(0, reviewsTop), { duration: 0.7, force: true });
          return;
        } catch (error) {}
      }

      window.scrollTo({ top: Math.max(0, reviewsTop), behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"]) return;
  try {
    
if (document.querySelector(".reviews__wrapper") != null) {
  if (window.innerWidth < 1200) {
    gsap.to(".reviews__wrapper > product-card-link:nth-of-type(1), .reviews__wrapper > product-card-link:nth-of-type(2), .reviews__wrapper > product-card-link:nth-of-type(3), .reviews__wrapper > product-card-link:nth-of-type(4), .reviews__wrapper > product-card-link:nth-of-type(5), .reviews__wrapper > product-card-link:nth-of-type(6)", {
      scrollTrigger: {
          trigger:".reviews__wrapper",
          scrub: true,
          start: "top bottom",
          end: "bottom top"
      },
      ease: Power0.easeNone,
      x: "-400px"
    });

    gsap.from(".reviews__wrapper > product-card-link:nth-of-type(7), .reviews__wrapper > product-card-link:nth-of-type(8), .reviews__wrapper > product-card-link:nth-of-type(9), .reviews__wrapper > product-card-link:nth-of-type(10), .reviews__wrapper > product-card-link:nth-of-type(11), .reviews__wrapper > product-card-link:nth-of-type(12)", {
      scrollTrigger: {
          trigger:".reviews__wrapper",
          scrub: true,
          start: "top bottom",
          end: "bottom top"
      },
      ease: Power0.easeNone,
      x: "-400px"
    });
  } else {
    gsap.to(".reviews__wrapper > product-card-link:nth-of-type(even)", {
      scrollTrigger: {
          trigger:".reviews__wrapper",
          scrub: true,
          start: "top bottom",
          end: "bottom top"
      },
      ease: Power0.easeNone,
      y: "-400px"
    });

    gsap.from(".reviews__wrapper > product-card-link:nth-of-type(odd)", {
      scrollTrigger: {
          trigger:".reviews__wrapper",
          scrub: true,
          start: "top bottom",
          end: "bottom top"
      },
      ease: Power0.easeNone,
      y: "-400px"
    });
  }
}

  } catch(e) { console.error(e); }
})();
})();
